module.exports = __webpack_public_path__ + "img/coral-clay-color.337e589d.jpg";